import { useRouter } from 'next/router';
import { useCallback, useEffect } from 'react';

export const useCurrentPaginationPage = (): number => {
  const router = useRouter();
  return router.query.page ? Number(router.query.page) - 1 : 0;
};

export const usePagination = (currentPage: number, totalPages: number) => {
  const router = useRouter();

  const onPageChange = (page: number) => {
    const query = { ...router.query };

    if (page === 1) {
      delete query.page;
    } else {
      query.page = `${page}`;
    }

    router.push(
      {
        pathname: router.pathname,
        query,
      },
      undefined,
      { shallow: true },
    );
  };

  const redirectToMainpage = useCallback(() => {
    const query = { ...router.query };

    delete query.page;

    router.push(
      {
        pathname: router.pathname,
        query,
      },
      undefined,
      { shallow: true },
    );
  }, [router]);

  useEffect(() => {
    if (currentPage >= totalPages && currentPage !== 0) {
      redirectToMainpage();
    }
  }, [currentPage, totalPages, redirectToMainpage]);

  return { redirectToMainpage, onPageChange };
};
